import { type EnvironmentId, type ThreadId } from "@cmmd-forge/contracts";
import { scopeThreadRef } from "@cmmd-forge/client-runtime";

export function resolveCanonicalThreadRouteRef(input: {
  readonly routeThreadRef: { environmentId: EnvironmentId; threadId: ThreadId };
  readonly draftBackedThreadRef: { environmentId: EnvironmentId; threadId: ThreadId } | null;
  readonly threadAcrossEnvironments:
    | {
        environmentId: EnvironmentId;
        id: ThreadId;
      }
    | undefined;
}) {
  if (input.draftBackedThreadRef) {
    return input.draftBackedThreadRef;
  }
  if (input.threadAcrossEnvironments) {
    return scopeThreadRef(
      input.threadAcrossEnvironments.environmentId,
      input.threadAcrossEnvironments.id,
    );
  }
  return input.routeThreadRef;
}
